import { Flex } from "antd";
import i18next from "i18next";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAuthContext } from "../../../../contexts/AuthContext";
import query from "../../../../server/constants.api";
import logger from "../../../../server/server";
import useFetch from "../../../../server/useFetch";
import { renderFloor } from "../../../../utils/renders/render-helper";
import SimpleTooltip from "../../Atomics/SimpleTooltip";
import Spinner from "../../Atomics/Spinner";
import { ChartLegendComponent } from "../../Molecules/ChartLegendComponent/ChartLegendComponent";

const ChartLegend = styled.div`
  position: absolute;
  right: 3%;
  bottom: 3%;
`;

export const FloorVacancyComponent = ({
  building,
  currentFloor,
  metric,
  setOrbitControls,
  ...props
}) => {

  useEffect(() => {
    refetch()
  }, [i18next.resolvedLanguage])

  const { t } = useTranslation();
  const { user, tenant } = useAuthContext();
  const mountRef = useRef();
  const tooltipRef = useRef();
  const [objectHovered, setObjectHovered] = useState();
  const [metricLegend, setMetricLegend] = useState();

  const { data: buildingFloorOBJ, refetch, isFetching } = useFetch(
    "/registry/3DPlant", "buildingDetailOBJ",
    {
      id: currentFloor?.value,
      type: "FLOOR",
    },
    building?.id ?? false, null, query.middlewareURL);

  useEffect(() => {
    logger.info("User " + user?.Username + " is using FloorVacancyComponent successfully! Tenant: " + tenant);
  }, [])

  const onObjectHover = (object, top, left) => {
    tooltipRef.current.style.left = `${top}px`;
    tooltipRef.current.style.top = `${left}px`;
  };

  useEffect(() => {
    refetch();
  }, [metric]);

  useEffect(() => {
    if (buildingFloorOBJ && !isFetching) {
      let camera = {
        fov: 22,
        near: 0.1,
        far: 1000,
        position: { x: 22, y: 25, z: 22 },
        lookAt: { x: 0, y: 0, z: 0 },
      };

      let ambLight = {
        color: "white",
        intensity: 0.2,
      };

      let lights = [
        { x: 15, y: 20, z: -26 },
        { x: 15, y: 36, z: 15 },
      ];
      let renderProps = {
        camera,
        ambLight,
        lights,
        handleResize: true,
        onHover: onObjectHover,
        setHovered: setObjectHovered,
        onRightClick: (clickedObject) => { console.log("Right Clicked", clickedObject) },
        setOrbitControls: setOrbitControls,
      };

      setMetricLegend(buildingFloorOBJ?.floors?.n04?.[metric]?.legend.map(item => {
        return {
          circleColor: item?.color,   // Using the color property for the circle
          label: t(item?.text?.pt)      // Using the text property for the label
        };
      })
      );

      renderFloor(
        mountRef.current,
        buildingFloorOBJ?.floors?.n04,
        metric,
        renderProps
      );
    }
  }, [isFetching]);

  return (
    <>
      {!isFetching ? (
        <>
          <div
            style={{ width: "100%", height: "100%" }}
            ref={mountRef}
            className={props?.className}
          >
            <SimpleTooltip
              reference={tooltipRef}
              display={objectHovered?.value !== undefined ? "block" : "none"}
              text={t(objectHovered?.label)}
              value={objectHovered?.value}
            />
          </div>
          {metricLegend ? (
            <ChartLegend className="chart-legend">
              <ChartLegendComponent
                data={metricLegend}
              />
            </ChartLegend>
          ) : null}
        </>
      ) : (
        <Flex justify="center" styles={{ height: "100%" }}>
          <Spinner stroke="green" />
        </Flex>
      )}
    </>
  );
};
